import { toPng } from 'html-to-image';

type ShareTemplate = 'story_hero' | 'poster_report' | 'square_badge';

const shareTemplateSizes: Record<ShareTemplate, { width: number; height: number }> = {
  story_hero: { width: 1080, height: 1920 },
  poster_report: { width: 1440, height: 1920 },
  square_badge: { width: 1200, height: 1200 }
};

function shareTemplateFor(node: HTMLElement): ShareTemplate {
  const template = node.dataset.shareTemplate;
  if (template === 'poster_report' || template === 'square_badge' || template === 'story_hero') {
    return template;
  }
  return 'story_hero';
}

export async function generateShareImagePreview(selector: string) {
  const node = document.querySelector<HTMLElement>(selector);
  if (!node) throw new Error(`Share card node not found: ${selector}`);
  const template = shareTemplateFor(node);
  const size = shareTemplateSizes[template];

  return toPng(node, {
    canvasWidth: size.width,
    canvasHeight: size.height,
    cacheBust: true,
    pixelRatio: 2
  });
}
